export const ROLE_PRIVILEGES = {
	USER: 0,
	ADMIN: 1,
	SUPER_USER: 2,
};

export const ALWARQA_ORG_ID = '9gNxxjilc9sWDtvjL51c';
